function updateOrderDeadline() {
  // 1. 현재 UTC 기준 시간
  const nowUtc = new Date();

  // 2. 'America/Los_Angeles' 기준 오늘 날짜 구하기
  const nowInLA = new Date(nowUtc.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
  // 오늘 날짜(연-월-일만 추출)
  const laYear = nowInLA.getFullYear();
  const laMonth = nowInLA.getMonth();
  const laDate = nowInLA.getDate();

  // 3. LA 기준 오늘 오후 3시 (new Date(year, month, date, hour, minute, second, ms))
  const laCutoff = new Date(Date.UTC(laYear, laMonth, laDate, 22, 0, 0)); // 22:00 UTC = 15:00 LA (서머타임 자동반영됨)

  // 4. 만약 현재 LA 시간이 15시(3PM) 이후면, 마감 시간을 내일로 옮김
  if (nowInLA.getHours() >= 15) {
    // 내일 오후 3시
    const nextDay = new Date(nowInLA.getTime() + (24 * 60 * 60 * 1000));
    const nextYear = nextDay.getFullYear();
    const nextMonth = nextDay.getMonth();
    const nextDate = nextDay.getDate();
    laCutoff.setUTCFullYear(nextYear, nextMonth, nextDate);
  }

  // 5. 남은 시간 계산 (utc 기준)
  const diff = laCutoff - nowUtc;
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const secs = Math.floor((diff % (1000 * 60)) / 1000);

  const el = document.getElementById('deadline-countdown');
  if (el) {
    el.textContent = `${hours} Hrs ${mins} Mins ${secs} Secs`;
  }
}

setInterval(updateOrderDeadline, 1000);
updateOrderDeadline();
